import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Axios 401 hataları (auth interceptor tarafından zaten yönetiliyor) React dev overlay'ini
// tetiklememesi için sessizce yut. Diğer hatalar normal şekilde loglanmaya devam eder.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    const status = e?.reason?.response?.status;
    if (status === 401) {
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
